import React, { useState } from 'react';
import { useAlias, useGroupName } from 'src/data/redux';
import { HammerstoneAppLayout } from '../helpers';
import { Alert, Box, SpaceBetween, Toggle } from '@amzn/awsui-components-console';
import { DisplayMode } from '../helpers/content/contentInterfaces';
import { AdHocContainerLayout, createAdHocQueryWithFlashbar } from './AdHocQuery';
import ReactHookFormWrapper from '../helpers/ReactHookFormWrapper';
import { useForm } from 'react-hook-form';
import { CreateAdHocQueryBody } from '@amzn/aws-hammerstone-exposed-restful-service-typescript-client/clients/hammerstoneexposedrestfulservicelambda';
import { useLocation, useNavigate } from 'react-router-dom';
import { urlSearchString } from 'src/nav/navHelper';
import PAGES from 'src/nav/Pages';

export default function CreateAdHocQueryForm() {
	const groupName = useGroupName();
	const userAlias = useAlias();
	const navigate = useNavigate();
	const goBack = () =>
		navigate({
			pathname: PAGES.VIEW_AD_HOC_QUERY.path,
			search: urlSearchString({ groupName }),
		});

	const [shouldExecute, setShouldExecute] = useState<boolean>(true);
	const location = useLocation();
	const { selectQuery, clusterName } = location?.state ?? {};
	const form = useForm<CreateAdHocQueryBody>({
		defaultValues: { selectQuery, clusterName },
		mode: 'onTouched',
		reValidateMode: 'onChange',
	});

	return (
		<HammerstoneAppLayout {...PAGES.CREATE_AD_HOC_QUERY.pageLayoutProps({ groupName })}>
			<SpaceBetween size="xl">
				<ReactHookFormWrapper
					form={form}
					header={'Create new ad hoc query'}
					onCancel={goBack}
					onValidSubmit={(body: CreateAdHocQueryBody) => {
						createAdHocQueryWithFlashbar({ groupName, userAlias, body }, shouldExecute).then((queryId) => {
							if (queryId) {
								goBack();
							}
						});
					}}
					actions={
						<Box float="right" margin={{ top: 'xxs', right: 'xs' }}>
							<Toggle checked={shouldExecute} onChange={({ detail }) => setShouldExecute(detail.checked)}>
								Execute on create
							</Toggle>
						</Box>
					}
					submitName={shouldExecute ? 'Execute' : 'Save draft'}
				>
					<Alert type="info">
						Please note that for security and performance considerations, customers may only work on one ad
						hoc query at a time. By creating a new query, you will overwrite any existing query.
					</Alert>
					<AdHocContainerLayout queryId={null} mode={DisplayMode.Edit} />
				</ReactHookFormWrapper>
			</SpaceBetween>
		</HammerstoneAppLayout>
	);
}
